/* Agni desktop mega menu: isolated from the mobile drawer. */
(() => {
  const initialiseHeader = (header) => {
  if (!header || header.dataset.agniMegaMenuReady === 'true') return;

  header.dataset.agniMegaMenuReady = 'true';

  const items = Array.from(header.querySelectorAll('[data-agni-mega-item]'));
  const desktopQuery = window.matchMedia('(min-width: 1100px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const closeTimers = new WeakMap();

  const getToggle = (item) => item.querySelector('[data-agni-mega-toggle]');
  const getPanel = (item) => item.querySelector('[data-agni-mega-panel]');

  const setExpanded = (item, expanded) => {
    const toggle = getToggle(item);
    const panel = getPanel(item);

    if (!toggle || !panel) return;

    item.classList.toggle('is-open', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
  };

  const closeItem = (item) => {
    const timer = closeTimers.get(item);
    if (timer) window.clearTimeout(timer);
    closeTimers.delete(item);
    setExpanded(item, false);
  };

  const closeAll = (except) => {
    items.forEach((item) => {
      if (item !== except) closeItem(item);
    });
  };

  const openItem = (item) => {
    if (!desktopQuery.matches) return;
    const timer = closeTimers.get(item);
    if (timer) window.clearTimeout(timer);
    closeTimers.delete(item);
    closeAll(item);
    setExpanded(item, true);
  };

  const scheduleClose = (item) => {
    const existing = closeTimers.get(item);
    if (existing) window.clearTimeout(existing);

    const timer = window.setTimeout(() => {
      closeTimers.delete(item);
      const active = document.activeElement;
      if (!item.matches(':hover') && !item.contains(active)) closeItem(item);
    }, 700);

    closeTimers.set(item, timer);
  };

  items.forEach((item) => {
    const toggle = getToggle(item);
    const panel = getPanel(item);

    setExpanded(item, false);

    toggle.addEventListener('click', () => {
      if (!desktopQuery.matches) return;
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      if (willOpen) openItem(item);
      else closeItem(item);
    });

    item.addEventListener('focusin', () => openItem(item));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) scheduleClose(item);
    });

    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeItem(item);
      toggle.focus();
    });

    if (panel) {
      panel.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        closeItem(item);
        toggle.focus();
      });
    }

    item.addEventListener('mouseenter', () => {
      if (hoverQuery.matches) openItem(item);
    });
    item.addEventListener('mouseleave', () => {
      if (hoverQuery.matches) scheduleClose(item);
    });
  });

  const onDocumentPointerDown = (event) => {
    if (!header.contains(event.target)) closeAll();
  };

  const onDocumentKeyDown = (event) => {
    if (event.key !== 'Escape') return;
    const openItemElement = items.find((item) => item.classList.contains('is-open'));
    if (!openItemElement) return;
    closeItem(openItemElement);
    getToggle(openItemElement).focus();
  };

  const onViewportChange = () => {
    if (!desktopQuery.matches) closeAll();
  };

  document.addEventListener('pointerdown', onDocumentPointerDown);
  document.addEventListener('keydown', onDocumentKeyDown);
  desktopQuery.addEventListener('change', onViewportChange);

  const onSectionUnload = (event) => {
    if (!event.target.contains(header)) return;
    document.removeEventListener('pointerdown', onDocumentPointerDown);
    document.removeEventListener('keydown', onDocumentKeyDown);
    desktopQuery.removeEventListener('change', onViewportChange);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
  };

  document.addEventListener('shopify:section:unload', onSectionUnload);

  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-agni-mega-menu-root]').forEach(initialiseHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
